
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx",
      function () {
        return require("private-next-pages/es-mx/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx"])
      });
    }
  